import { render, staticRenderFns } from "./ServidorShow.vue?vue&type=template&id=133a347d&scoped=true&"
import script from "./ServidorShow.vue?vue&type=script&lang=js&"
export * from "./ServidorShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133a347d",
  null
  
)

export default component.exports